import { MdOutlineRemoveRedEye } from 'react-icons/md'

import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IReview } from '~/types/review'

import Tooltip from '~/components/Tooltip'

import './styles.scss'

const TextAndTranslationCellRenderer = ({
  value,
}: ICellRendererParams<IReview, { original: string; translation: string } | null>): ReactElement => {
  if (!value) {
    return <div />
  }

  const { original, translation } = value

  return (
    <div className="text-and-translation-cell-renderer-component">
      <div className="text-and-translation-cell-renderer-component__main-content">{translation}</div>
      {original.length > 0 ? (
        <Tooltip
          align={{ points: ['bl', 'tl'] }}
          mouseEnterDelay={0.2}
          overlay={<div className="message">{original}</div>}
          placement="topRight"
          trigger="hover"
        >
          <div className="text-and-translation-cell-renderer-component__translated-content">
            <MdOutlineRemoveRedEye color="#ff5301" size={15} />
            <div className="text-and-translation-cell-renderer-component__translated-content__text">
              View original version
            </div>
          </div>
        </Tooltip>
      ) : null}
    </div>
  )
}
export default TextAndTranslationCellRenderer
